import React from "react";
import SlideShow from "../slides/SlideShow";
import hitachiLogo from '../../images/HitachiLogo.png';

interface Props {
    changeStepClick: (stepName: string) => void;
}

const Home: React.FC<Props> = ({ changeStepClick }) => {
    return (
        <>
            <h1>Velkommen</h1>
            <img id="logo" src={hitachiLogo} alt="Hitachi logo" />
            <div className='button-container'>
                <div className='button pink' onClick={() => changeStepClick("selectHost")}>Jeg har en aftale</div>
                <div className='button green' onClick={() => changeStepClick("notPlanned")}>Jeg kommer uanmeldt</div>
                <div className='button' onClick={() => {}}>Check ud</div>
            </div>
            <div className='slider-container'>
                <SlideShow slideShowId={10040} className='top-slide' />
                <SlideShow slideShowId={10041} className='bottom-slide' />
            </div>
        </>
    );
};

export default Home;